import { Injectable } from '@angular/core';
import { BookingEvent } from '@deltager/organizers/admin/shared/models/booking-event.model';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@deltager/organizers/admin/environments/environment';
import { Operation } from 'fast-json-patch';
import { map } from 'rxjs/operators';
import { CustomValidation } from '@deltager/organizers/admin/modules/booking-event-setup/models/booking-custom-field.model';
import { BookingEventHeader } from '../models/booking-event-header.model';

@Injectable({
  providedIn: 'root',
})
export class BookingEventService {
  private readonly bookingEventBaseUrl = `${environment.apiBaseURL}/booking-events`;

  constructor(private http: HttpClient) {}

  getHeader(bookingEventId: number): Observable<BookingEventHeader> {
    return this.http.get<BookingEventHeader>(`${this.bookingEventBaseUrl}/${bookingEventId}/header`);
  }

  create(bookingEvent: BookingEvent, wizardId: number): Observable<number> {
    return this.http.post<number>(this.bookingEventBaseUrl + `?wid=${wizardId}`, bookingEvent);
  }

  copy(bookingEventId: number): Observable<number> {
    return this.http.post<any>(`${this.bookingEventBaseUrl}/${bookingEventId}/copy`, {});
  }

  publish(bookingEventId: number): Observable<any> {
    return this.http.post<any>(`${this.bookingEventBaseUrl}/${bookingEventId}/publish`, {});
  }

  update(bookingEventId: number, updateOperations: Operation[], draftMode?: boolean): Observable<void> {
    const url = `${this.bookingEventBaseUrl}/${bookingEventId}` + (draftMode ? '?draftMode=true' : '');
    return this.http
      .patch(url, updateOperations, {
        headers: {
          'Content-Type': 'application/json-patch+json',
        },
      })
      .pipe(map(_ => {}));
  }

  verifyBookingEventUrlAvailable(bookingEventId: number, customUrl: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.bookingEventBaseUrl}/${bookingEventId}/urls/${customUrl}`);
  }

  getRegistrationsCount(eventId: number): Observable<number> {
    return this.http.get<number>(`${environment.apiBaseURL}/booking-events/${eventId}/registrations-count`);
  }

  remove(bookingEventId: number): Observable<any> {
    return this.http.delete<any>(`${environment.apiBaseURL}/booking-events/${bookingEventId}`);
  }

  archive(bookingEventId: number): Observable<any> {
    return this.http.put<any>(`${environment.apiBaseURL}/booking-events/${bookingEventId}/archive`, {});
  }

  unarchive(bookingEventId: number): Observable<any> {
    return this.http.put<any>(`${environment.apiBaseURL}/booking-events/${bookingEventId}/unarchive`, {});
  }

  getCustomFieldValidations(organizerId: number): Observable<CustomValidation[]> {
    return this.http.get<CustomValidation[]>(
      `${environment.apiBaseURL}/organizers/${organizerId}/custom_validations`,
      {},
    );
  }
}
